<template>
  <div id="onebyone-gateway-wrapper">
    <div id="top-campaign-carousel" v-if="topCampaigns">
      <v-carousel height="700px" hide-delimiter-background>
        <v-carousel-item
          v-for="(campaign, index) in topCampaigns"
          :key="index"
          :to="campaign.url"
          cycle
          eager
          :ripple="false"
          :src="getImage(campaign.image)"
        ></v-carousel-item>
      </v-carousel>
    </div>
    <div
      id="new-release-campaign-wrapper"
      class="d-flex justify-center"
      v-if="newReleasesCampaignProducts"
    >
      <div
        id="new-release-campaign-content"
        class="campaign-content-section"
        v-for="(newReleaseProduct, index) in newReleasesCampaignProducts"
        :key="index"
      >
        <v-img id="new-release-product-image" :src="getImage(newReleaseProduct.image)"></v-img>
        <div
          id="new-release-product-description"
          class="d-flex justify-center align-center elevation-7"
        >
          <div class="red-line left"></div>
          <div class="red-line right"></div>
          <div id="new-release-product-description-content">
            <div
              class="new-release-product-title verdana-font-family"
            >{{ parseMetadata(newReleaseProduct.metadata).title }}</div>
            <div
              class="new-release-product-full-title font-size-14 verdana-font-family mt-1"
            >{{ parseMetadata(newReleaseProduct.metadata).subtitle }}</div>
            <div
              class="new-release-product-brief-description font-size-14 verdana-font-family mt-3"
            >{{ parseMetadata(newReleaseProduct.metadata).description }}</div>
            <div class="new-releae-product-shop-now-section">
              <router-link :to="newReleaseProduct.url">
                <div
                  class="shop-animate-button new-releae-product-shop-now-button font-size-14 verdana-font-family d-flex justify-center align-center"
                >Shop Now ></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="best-seller-campaign-wrapper"
      class="verdana-font-family d-flex justify-center align-center"
      v-if="bestSellerCampaignProducts"
    >
      <div id="best-seller-campaign-content" class="campaign-content-section text-center">
        <div id="best-seller-title">Bestsellers</div>
        <div
          id="best-seller-short-description"
        >Auto Record Your Weight Data - Free 1byone Health APP, can record your daily weight data intelligently...</div>
        <div id="best-seller-products-section-wrapper" class="d-flex justify-space-between">


          <div
            class="best-seller-single-product-wrapper"
            v-for="(product, index) in bestSellerCampaignProducts"
          
            v-if="index==0"
          >
            <router-link :to="{path:'/B05'}">
              <div class="red-line bs-decor-left hover-decor-left"></div>
              <div class="red-line bs-decor-right hover-decor-right"></div>
              <div class="best-seller-product-image mx-auto">
                <v-img :src="getImage(product.image)" height="280px" contain></v-img>
              </div>
              <div class="best-seller-product-title">{{ parseMetadata(product.metadata).title }}</div>
              <div
                class="best-seller-product-description font-size-14 mx-auto text-left"
              >{{ parseMetadata(product.metadata).description }}</div>
              <div
                class="best-seller-product-shop-now font-size-14 shop-animate-button d-flex justify-center align-center mx-auto"
              >Shop Now ></div>
            </router-link>
          </div>

            <div
            class="best-seller-single-product-wrapper"
            v-for="(product, index) in bestSellerCampaignProducts"
            v-if="index==1"
          >
            <router-link :to="{path:'/B0000008'}">
              <div class="red-line bs-decor-left hover-decor-left"></div>
              <div class="red-line bs-decor-right hover-decor-right"></div>
              <div class="best-seller-product-image mx-auto">
                <v-img :src="getImage(product.image)" height="280px" contain></v-img>
              </div>
              <div class="best-seller-product-title">{{ parseMetadata(product.metadata).title }}</div>
              <div
                class="best-seller-product-description font-size-14 mx-auto text-left"
              >{{ parseMetadata(product.metadata).description }}</div>
              <div
                class="best-seller-product-shop-now font-size-14 shop-animate-button d-flex justify-center align-center mx-auto"
              >Shop Now ></div>
            </router-link>
          </div>


            <div
            class="best-seller-single-product-wrapper"
            v-for="(product, index) in bestSellerCampaignProducts"
            v-if="index==2"
          >
            <router-link :to="{path:'/A05'}">
              <div class="red-line bs-decor-left hover-decor-left"></div>
              <div class="red-line bs-decor-right hover-decor-right"></div>
              <div class="best-seller-product-image mx-auto">
                <v-img :src="getImage(product.image)" height="280px" contain></v-img>
              </div>
              <div class="best-seller-product-title">{{ parseMetadata(product.metadata).title }}</div>
              <div
                class="best-seller-product-description font-size-14 mx-auto text-left"
              >{{ parseMetadata(product.metadata).description }}</div>
              <div
                class="best-seller-product-shop-now font-size-14 shop-animate-button d-flex justify-center align-center mx-auto"
              >Shop Now ></div>
            </router-link>
          </div>

          

        </div>
        <router-link to="/product/browse">
          <div
            id="best-seller-shop-all"
            class="d-flex justify-center align-center mx-auto shop-animate-button"
          >SHOP ALL ></div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import homepageMixins from "../../mixins/homepageMixins";
import bus from '../../api/bus';
import { defaultAxiosConfig } from "../../api/apiConfig";
export default {
  // created:function(){
  //     //  this.Grade();
  //     //  this.CU();
  //     //  this.Guide();
  //     if(sessionStorage.getItem("amazonUserinfo")!=null){
  //     let  _this = this;
  //     bus .$emit("showHomebox",true);  
  //     }else{
  //     let  _this = this;
  //     bus .$emit("showHomebox",false);  
  //     } },

  created:function(){
        this.pcHomeRecord();
    
       },

   methods: {
     pcHomeRecord(){
        this.$axios({
              url: defaultAxiosConfig.baseURL+"/website/totalData",

              //  url: "http://localhost:5000/website/totalData",
              method: "post",
              params: {"location": "home","type": "PC"}
            }).then(res => {
              console.log(res);
            });
     }

   },

  mixins: [homepageMixins("desktop")],
  metaInfo: {
    title:
      "1byone health |  body fat scale, blood pressure monitor, oximeter, tens and etc",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health features houshold health products including bluetooth body fat scale,  blood pressure monitor, oximeter, tens and more, providing professional service, technology and best products."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone.com, 1byonehealth.com, 1byonehealth, health, zoetouch, beautural, bluetooth, body fat scale, bathroom scale, smart scale, body scale, scale, oximeter, blood pressure monitor, tens"
      }
    ]
  
  }
  
};
</script>

<style scoped>
#onebyone-gateway-wrapper {
  width: 100%;
  background-color: #f6f6f7;
}

.shop-animate-button {
  color: #e2211c;
  border: 2px solid #e2211c;
  border-radius: 3px;
  background-size: 200% 200%;
  background-image: linear-gradient(to top, #e2211c 50%, transparent 50%);
  transition: 0.8s;
}

.shop-animate-button:hover {
  background-image: linear-gradient(to top, #e2211c 51%, transparent 50%);
  background-position: 0 100%;
  color: white;
}

#new-release-campaign-wrapper {
  margin-top: 84px;
}

.campaign-content-section {
  max-width: 1400px;
  min-width: 1000px;
  position: relative;
  width: 80%;
}

#new-release-product-image {
  width: 90%;
}

#new-release-product-description {
  max-width: 500px;
  max-height: 340px;
  width: 37%;
  height: 54.8%;
  background-color: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}

#new-release-product-description-content {
  width: 78%;
  height: 53%;
  position: relative;
}

@media only screen and (max-width: 1439px) {
  #new-release-product-description-content {
    height: 80%;
  }
}

.new-release-product-title {
  font-size: 22px;
  color: #e2211c;
  font-weight: 500;
}

.new-release-product-full-title {
  color: #666666;
  font-weight: 500;
}

.new-release-product-brief-description {
  color: #999999;
  font-weight: 500;
}

.new-releae-product-shop-now-button {
  height: 35px;
  width: 105px;
  position: absolute;
  bottom: 0px;
}

.red-line {
  width: 28px;
  border-bottom: 6px solid #e2211c;
  position: absolute;
}

.left {
  left: -14px;
  top: 14.7%;
}

.right {
  bottom: 14.7%;
  right: -14px;
}

#best-seller-campaign-wrapper {
  margin-top: 85px;
}

#best-seller-title {
  font-size: 48px;
  color: #333333;
}

#best-seller-short-description {
  font-size: 15px;
  font-weight: 500;
  color: #999999;
}

#best-seller-products-section-wrapper {
  margin-top: 66px;
}

.best-seller-single-product-wrapper {
  width: 32.3%;
  height: 100%;
  background-color: white;
  position: relative;
  transition: 0.6s;
}

.best-seller-product-image {
  margin-top: 113px;
  width: 61.8%;
}

.best-seller-product-title {
  font-size: 18px;
  color: #333333;
  margin-top: 73px;
}

.best-seller-product-description {
  color: #999999;
  margin-top: 26px;
  max-width: 353px;
  padding-left: 5px;
  padding-right: 5px;
}

.best-seller-product-shop-now {
  height: 35px;
  width: 105px;
  margin-top: 39px;
  margin-bottom: 50px;
  opacity: 0;
}

#best-seller-shop-all {
  height: 60px;
  width: 140px;
  font-size: 18px;
  margin-top: 70px;
  margin-bottom: 70px;
}

.bs-decor-left {
  left: -30px;
  top: 45px;
  opacity: 0;
  transition: 1s;
}

.bs-decor-right {
  bottom: 45px;
  right: -30px;
  opacity: 0;
  transition: 1s;
}

.best-seller-single-product-wrapper:hover {
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}

.best-seller-single-product-wrapper:hover .hover-decor-left {
  left: -15px;
  opacity: 1;
}

.best-seller-single-product-wrapper:hover .hover-decor-right {
  right: -15px;
  opacity: 1;
}

.best-seller-single-product-wrapper:hover .best-seller-product-shop-now {
  opacity: 1;
}
</style>


